import { inject, provide } from 'vue';
import {
	preferencesStoreKey,
	type PreferencesStore,
} from './preferences.model';

/**
 * Used when no app has provided a store. Every getter answers "nothing saved"
 * and every setter discards, so a component renders correctly and simply does
 * not remember anything — the behavior outside the dashboard.
 */
const noopPreferencesStore: PreferencesStore = {
	getPerPage: () => null,
	setPerPage: () => {},
	clearPerPage: () => {},
	getColumnWidths: () => null,
	setColumnWidths: () => {},
	clearColumnWidths: () => {},
	getSort: () => null,
	setSort: () => {},
	clearSort: () => {},
	getColumnOrder: () => null,
	setColumnOrder: () => {},
	clearColumnOrder: () => {},
	getColumnVisibility: () => null,
	setColumnVisibility: () => {},
	clearColumnVisibility: () => {},
	getDataListSelection: () => [],
	setDataListSelection: () => {},
	clearDataListSelection: () => {},
	getDataListSelectionPanelOpen: () => false,
	setDataListSelectionPanelOpen: () => {},
	getAdvancedFilterLayoutMode: () => null,
	setAdvancedFilterLayoutMode: () => {},
	getAdvancedFilterCollapseOpen: () => null,
	setAdvancedFilterCollapseOpen: () => {},
};

export const providePreferencesStore = (store: PreferencesStore) => {
	provide(preferencesStoreKey, store);
};

export const usePreferencesStore = (): PreferencesStore =>
	inject(preferencesStoreKey, noopPreferencesStore);
